// Components/Banner/UpdateBanner.jsx
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";
import { successToast, errorToast } from "../../Utils/toast";
import { useUpdateBannerMutation } from "../../redux/services/bannerService/banner.Services";

function UpdateBanner({ data }) {
  const dispatch = useDispatch();
  const [updateBanner, { isLoading }] = useUpdateBannerMutation();
  
  const [formData, setFormData] = useState({
    id: data?.id,
    name: data?.name || "",
    description: data?.description || "",
    status: data?.status === "active" ? "active" : "inactive",
    link: data?.link || "",
    image: null
  });

  const [preview, setPreview] = useState(
    data?.image && data?.imageBaseUrl
      ? `${data.imageBaseUrl}${data.image}`
      : null
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        image: file,
      });
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleUpdate = async () => {
    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("description", formData.description);
      form.append("status", formData.status);
      form.append("link", formData.link);

      if (formData.image) {
        form.append("image", formData.image);
      }

      const res = await updateBanner({
        id: formData.id,
        formData: form,
      }).unwrap();

      successToast(res?.message || "Banner Updated Successfully 🚀");
      dispatch(closeModal());
    } catch (error) {
      console.log(error);
      errorToast(error?.data?.message || "Update Failed ❌");
    }
  };

  return (
    <div className="custom-modal-body">
      <div className="mb-3">
        <label>Banner Name *</label>
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="form-control"
          required
        />
      </div>

      <div className="mb-3">
        <label>Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="form-control"
          rows="4"
        />
      </div>

      <div className="mb-3">
        <label>Link</label>
        <input
          name="link"
          value={formData.link}
          onChange={handleChange}
          className="form-control"
          placeholder="https://example.com"
        />
      </div>

      <div className="mb-3">
        <label>Status</label>
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="form-select"
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <div className="mb-3">
        <label>Banner Image</label>
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={handleImageChange}
        />

        {preview && (
          <img
            src={preview}
            alt="Preview"
            style={{
              width: "100px",
              marginTop: "10px",
              borderRadius: "10px",
              border: "1px solid #ddd",
              padding: "5px",
            }}
          />
        )}
      </div>

      <div className="d-flex gap-2">
        <button
          className="btn btn-secondary"
          onClick={() => dispatch(closeModal())}
        >
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={handleUpdate}
          disabled={isLoading}
        >
          {isLoading ? "Updating..." : "Update Banner"}
        </button>
      </div>
    </div>
  );
}

export default UpdateBanner;